import React from "react";
import { BarChart, Bar, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import { FilterYearOnly } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExceltCatLabelName } from "../../functions/Report.ExportCatheterType";
import { formatDataLabelCatheterType } from "../../utils/Report.Format";
import {
  BARCHART,
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEBODY,
  STYLEHEAD,
} from "../../../../utils/useStyle";

const ReportCountLabelCatheterType = ({ userDept }) => {
  const [loading, setLoading] = React.useState(false);
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [data, setData] = React.useState({
    picc1: 0,
    picc2: 0,
    picc3: 0,
    picc4: 0,
    picc5: 0,
    central1: 0,
    central2: 0,
    central3: 0,
    central4: 0,
    checkCentral: [],
  });

  const listPicc = [
    { name: "Arrow 5 Fr 2-lumen PICC", count: data?.picc1 },
    { name: "Arrow 4 Fr 1-lumen PICC", count: data?.picc2 },
    { name: "Bard 5 Fr 2-Lumen power PICC", count: data?.picc3 },
    { name: "Vygon 3 Fr 1-lumen PICC", count: data?.picc4 },
    { name: "Other", count: data?.picc5 },
  ];

  const listCentral = [
    {
      name: "Arrow 7 Fr 2-lumen CVL, antimicrobials coated",
      count: data?.central1,
    },
    {
      name: "Arrow 7 Fr 3-lumen CVL, antimicrobials coated",
      count: data?.central2,
    },
    { name: "12 Fr DLC", count: data?.central3 },
    { name: "Other", count: data?.central4 },
  ];

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await reportAPI.getLabelCatheterTypeReport({
          year: String(year?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching label catheter type report:", error);
      }
    };
    fetchData();
  }, [year, userDept]);

  return (
    <div>
      <div className="flex">
        <div className="my-20">
          <div className={SCREENIPAD}>
            <div className={STYLEHEAD}>
              นับชนิดของสายน้ำเกลือแยกตามชื่อสายที่ใส่ (PICC line)
              <div className={STYLEBODY}>ของปี " {year?.label}"</div>
            </div>
            <div className={FLEXDROPDOWN}>
              <FilterYearOnly year={year} setYear={setYear} />
              <ButtonExcel
                text={"DOWNLOAD EXCEL"}
                onClick={() => {
                  ExceltCatLabelName(
                    formatDataLabelCatheterType(data),
                    year,
                    setLoading
                  );
                }}
                loading={loading}
              />
            </div>
          </div>
          <div className={BARCHART}>
            <BarChart
              width={700}
              height={300}
              data={listPicc}
              margin={{
                top: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <YAxis />
              <Tooltip />
              <Bar
                dataKey="count"
                fill="#a5f3fc"
                minPointSize={5}
                label={{ fill: "#111827" }}
              />
            </BarChart>
          </div>
          <div className="flex ml-16 ">
            <div className="mr-4 text-center">
              Arrow 5<div>Fr 2-lumen PICC</div>
            </div>
            <div className="mr-7 text-center">
              Arrow 4<div>Fr 1-lumen PICC</div>
            </div>
            <div className="mr-7 text-center">
              Bard 5<div>Fr 2-Lumen</div>
              <div>power PICC</div>
            </div>
            <div className="mr-12 text-center">
              Vygon 3<div>Fr 1-lumen PICC</div>
            </div>
            <div className="mr-6">Other</div>
          </div>
        </div>
      </div>
      <div className="flex">
        <div className="my-20">
          <div className={SCREENIPAD}>
            <div>
              <div className={STYLEHEAD}>
                นับชนิดของสายน้ำเกลือแยกตามชื่อสายที่ใส่ (Central Line)
                <div className={STYLEBODY}>ของปี " {year?.label}"</div>
              </div>
            </div>
          </div>
          <div className={BARCHART}>
            <BarChart
              width={700}
              height={300}
              data={listCentral}
              margin={{
                top: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <YAxis />
              <Tooltip />
              <Bar
                dataKey="count"
                fill="#38bdf8"
                minPointSize={5}
                label={{ fill: "#111827" }}
              />
            </BarChart>
          </div>
          <div className="flex ml-20 ">
            <div className="mr-14 text-center">
              Arrow 7<div>Fr 2-lumen CVL,</div>
              <div>antimicrobials</div>
              <div>coated</div>
            </div>
            <div className="mr-14 text-center">
              Arrow 7<div>Fr 3-lumen CVL,</div>
              <div>antimicrobials</div>
              <div>coated</div>
            </div>
            <div className="mr-28 text-center">12 Fr DLC</div>
            <div className="">Other</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportCountLabelCatheterType;
